import React from 'react';

export default function KpiTile({
  label,
  value,
  helper,
  tone = 'default',
  'data-testid': testId,
}) {
  const toneClass =
    tone === 'bronze'
      ? 'text-charcoal'
      : tone === 'muted'
      ? 'text-muted-foreground'
      : 'text-charcoal';

  return (
    <div
      data-testid={testId}
      className="rounded-sm bg-[#3A3936] px-5 py-4 border-t border-[#957C5D]/60 shadow-[0_18px_40px_-28px_rgba(58,57,54,0.7)]"
    >
      <div className="text-[10px] font-medium uppercase tracking-[0.18em] text-[#B5AFA5]">
        {label}
      </div>
      <div className={`mt-2 font-display text-xl sm:text-2xl md:text-[28px] leading-tight tracking-tight tabular-nums break-words ${toneClass === 'text-muted-foreground' ? 'text-[#D8D0C4]' : 'text-[#F7F5F1]'}`}>
        {value}
      </div>
      {helper && (
        <div className="mt-1 text-xs text-[#B5AFA5]">{helper}</div>
      )}
    </div>
  );
}
